import React, { useState } from 'react';
import { useAuth } from '../context/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { FaSpinner, FaExclamationTriangle } from 'react-icons/fa';

export function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const loggedInUser = await login(email, password);
            if (loggedInUser.role === 'superadmin') {
                navigate('/superadmin');
            } else if (loggedInUser.role === 'agent' || loggedInUser.role === 'admin') {
                navigate('/dashboard');
            } else {
                navigate('/'); // Fallback
            }
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.message || 'Invalid email or password.';
            setError(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen w-full flex items-center justify-center p-4 bg-gray-900 font-sans bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gray-700/20 to-gray-900">
            <div className="w-full max-w-md bg-black/20 backdrop-blur-lg border border-gray-700 rounded-2xl shadow-2xl p-8">
                
                {/* Header */}
                <div className="text-center mb-8">
                    
                    <h1 className="text-3xl font-bold text-white">Secure Sign In</h1>
                    <p className="text-gray-400">Enter your credentials to access the portal.</p>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} className="space-y-6">
                    {error && (
                        <div className="bg-red-500/10 border border-red-500/30 text-red-400 p-3 rounded-md text-sm flex items-center gap-2">
                            <FaExclamationTriangle /> {error}
                        </div>
                    )}
                    
                    {/* Email Input */}
                    <div>
                        <label className="block text-sm font-medium text-gray-400 mb-2" htmlFor="email">
                            Email Address
                        </label>
                        <input
                            type="email" id="email" value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full bg-gray-900/50 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-all"
                            placeholder="agent@void.com" required
                        />
                    </div>

                    {/* Password Input */}
                    <div>
                        <label className="block text-sm font-medium text-gray-400 mb-2" htmlFor="password">
                            Password
                        </label>
                        <input
                            type="password" id="password" value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full bg-gray-900/50 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-all"
                            placeholder="••••••••••" required
                        />
                    </div>

                    {/* Submit Button */}
                    <button type="submit"
                        className="w-full flex items-center justify-center bg-cyan-600 text-white py-3 rounded-lg font-semibold hover:bg-cyan-700 transition-colors disabled:bg-gray-600 disabled:cursor-not-allowed"
                        disabled={isLoading}>
                        {isLoading ? <FaSpinner className="animate-spin" /> : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
}